import { ApiError } from '@gorila-shared-ui/components';
import {
  EditMaintenanceConfigurationRequest,
  ConfigurationTriggerType,
  MaintenanceConfiguration,
  MaintenanceConfigurationRequest,
  MaintenanceType,
  MaintenanceTypeRequest,
} from '../types/maintenances';
import { getRequest, postRequest } from './api';
import { URLS } from './urls/urls';

export const getMaintenanceTypes = async ({
  page,
  search = '',
  allItems = false,
}: {
  page: number;
  search?: string;
  allItems?: boolean;
}): Promise<{ types?: MaintenanceType[]; hasNext?: boolean; error?: ApiError; total?: number }> => {
  const queryParams = { page, allItems, search };
  const response = await getRequest(URLS.maintenances.types.all, {
    queryParams,
  });

  return {
    total: response?.data?.total,
    types: response?.data?.items,
    hasNext: response?.data?.hasNext,
    error: response?.error,
  };
};

export const createMaintenanceType = async (
  data: MaintenanceTypeRequest
): Promise<{ id?: string; error?: ApiError }> => {
  const response = await postRequest(URLS.maintenances.types.create, {
    body: data,
  });

  return {
    id: response?.data?.id,
    error: response?.error,
  };
};

export const updateMaintenanceType = async (
  maintenanceTypeId: string,
  data: MaintenanceTypeRequest
): Promise<{ id?: string; error?: ApiError }> => {
  const response = await postRequest(URLS.maintenances.types.update(maintenanceTypeId), {
    body: data,
  });

  return {
    id: response?.data?.id,
    error: response?.error,
  };
};

export const getMaintenanceConfigurations = async ({
  page,
  maintenanceTypeId,
  triggerType,
  search = '',
  allItems = false,
}: {
  page: number;
  maintenanceTypeId?: string;
  triggerType?: ConfigurationTriggerType;
  search?: string;
  allItems?: boolean;
}): Promise<{
  configurations?: MaintenanceConfiguration[];
  hasNext?: boolean;
  error?: ApiError;
  total?: number;
}> => {
  const queryParams = { page, allItems, search, maintenanceTypeId, triggerType };
  const response = await getRequest(URLS.maintenances.configurations.all, {
    queryParams,
  });

  return {
    total: response?.data?.total,
    configurations: response?.data?.items,
    hasNext: response?.data?.hasNext,
    error: response?.error,
  };
};

export const createMaintenanceConfiguration = async (
  data: MaintenanceConfigurationRequest
): Promise<{ id?: string; error?: ApiError }> => {
  const response = await postRequest(URLS.maintenances.configurations.create, {
    body: data,
  });

  return {
    id: response?.data?.id,
    error: response?.error,
  };
};

export const updateMaintenanceConfiguration = async (
  configurationId: string,
  data: EditMaintenanceConfigurationRequest
): Promise<{ id?: string; error?: ApiError }> => {
  const response = await postRequest(URLS.maintenances.configurations.update(configurationId), {
    body: data,
  });

  return {
    id: response?.data?.id,
    error: response?.error,
  };
};
